// extracted by mini-css-extract-plugin
export default {"actions":"FavoriteFolderRow-actions-vOUqv TableRowCell-cell-giPrj"};